import React from 'react';
import { GraduationCap, Briefcase, Globe, Target } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { personalInfo } from '../mock';

const About = ({ isVisible }) => {
  const highlights = [
    {
      icon: GraduationCap,
      title: 'Academic Excellence',
      description: 'International Management at Audencia Business School'
    },
    {
      icon: Globe,
      title: 'Global Perspective',
      description: 'Experience across France, Germany, and Burkina Faso'
    },
    {
      icon: Briefcase,
      title: 'HR & Recruitment Experience',
      description: 'End-to-end recruitment, personnel administration, and talent sourcing across multiple sectors'
    },
    {
      icon: Target,
      title: 'Career Goal',
      description: 'Seeking a 6-month internship in International Human Resources starting January 2027'
    }
  ];

  return (
    <section id="about" data-section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div
          className={`transition-all duration-1000 delay-100 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900 text-center mb-4">
            About Me
          </h2>
          <div className="w-24 h-1 bg-blue-700 mx-auto mb-12"></div>

          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
              <div>
                <img
                  src="https://images.unsplash.com/photo-1507679799987-c73779587ccf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NjAwMjg2MjJ8MA&ixlib=rb-4.1.0&q=85"
                  alt="Professional"
                  className="rounded-lg shadow-2xl w-full h-auto object-cover"
                />
              </div>
              <div>
                <p className="text-lg text-slate-700 mb-6 leading-relaxed">
                  {personalInfo.bio}
                </p>
                <p className="text-lg text-slate-700 leading-relaxed">
                  {personalInfo.about}
                </p>
              </div>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {highlights.map((item, index) => {
                const Icon = item.icon;
                return (
                  <Card
                    key={index}
                    className="border-2 border-slate-200 hover:border-blue-700 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-2"
                  >
                    <CardContent className="p-6 text-center">
                      <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <Icon className="text-blue-700" size={32} />
                      </div>
                      <h3 className="font-semibold text-blue-900 mb-2">{item.title}</h3>
                      <p className="text-sm text-slate-600">{item.description}</p>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
